import React, { useState } from 'react';

import RequestService from "../../services/request.service";

import AuthService from '../../features/auth/auth.service'

import { Button, Modal } from 'react-bootstrap';

import { toast } from 'react-toastify'


import { Form, Col, Row } from 'react-bootstrap'

import { Formik } from 'formik';
import * as yup from 'yup';


import Dialog from '../../services/Dialogs'



const ModalBoutiquesPendienteAgregar = ( params : any ) => {

  const user = AuthService.getCurrentUser()

  const { show, handleClose, boutique } = params




  const dialog = new Dialog();


  const mensajes_validacion_generico = "Este campo es obligatorio"
  const schema = yup.object().shape({
          descripcion : yup.string().required(mensajes_validacion_generico),
  });


  const [ envio_server, setSeEnvio ] = useState<boolean>(false)


  const enviarFormulario = async (registro:any,event:any) =>{
        await dialog.open({
          accept: 'Si',
          cancel: 'Espera',
          dialogClass: '',
          message: '¿Estás seguro?',
          target: event.target,
          template: ''
        })
        let dialogo : any = await dialog.waitForUser()
        if(dialogo){
          try{

          setSeEnvio(true)
          let res_ = await RequestService.create( `boutique/agregar_pendiente/${boutique.uuid}` , { ...registro })

          if(res_){
            toast.success('El Pendiente fué agregado correctamento')
            setTimeout(()=>{
              handleClose()
            },0)
          }
          else{
            toast.error('Problemas...')
          } 
          }
          catch(e:any){
            toast.error(e.response.data)
            // console.log(e.response.data)
          } 
          
        }
       
  }





  return (
    <>
      <Modal show={show} onHide={handleClose} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Agregar Pendiente</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {
            // JSON.stringify(boutique)
          }


          <Formik
            validationSchema={schema}
            onSubmit={(values,e)=>{enviarFormulario(values, e)}}
            initialValues={{
                  descripcion : "",
            }}
          >
            {({
              handleSubmit,
              handleChange,
              setFieldValue,
              handleBlur,
              values,
              touched,
              isValid,
              errors,
            }) => (
              <Form id='my-form' noValidate onSubmit={handleSubmit}>


                  <Form.Group className="mb-3" controlId="descripcion">
                    <Form.Label>Detalles del Pendiente</Form.Label>
                    <Form.Control
                      as="textarea"
                      required
                      rows={20}
                      name="descripcion"
                      value={values.descripcion}
                      onBlur={(e)=>{ setFieldValue('descripcion', e.target.value.toUpperCase() ) }}
                      onChange={(e)=>{ setFieldValue('descripcion', e.target.value ) }}
                      isInvalid={!!errors.descripcion}
                      style={{textTransform:'uppercase'}}
                    />
                    <Form.Control.Feedback type="invalid"> {<>{errors.descripcion}</>} </Form.Control.Feedback>
                  </Form.Group>



              </Form>
            )}
          </Formik>


        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancelar
          </Button>
          <Button variant="success" form='my-form' type="submit">Guardar <i className="fa fa-save"/></Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}


export default ModalBoutiquesPendienteAgregar;